export const roles = {
  INDEX: '/roles',
}
